import React from "react";

import DashboardBarChart from "../../../CommonComponents/Dashboard/DashboardBarChart/DashboardBarChart";

import "./stylesProviderDistribution.css";
import RebetLoader from "../../../CommonComponents/RebetLoader/RebetLoader";

function ProviderDistribution({ isApiRunning }) {
  const keyFeatures = {
    labels: ["Jul 2024", "Aug 2024", "Sep 2024", "Oct 2024", "Nov 2024"],
    datasets: [
      {
        label: "SpinLogic Games",
        data: [100, 50, 75, 25, 50],
        backgroundColor: ["#6177E8"],
        borderColor: ["#6177E8"],
        borderWidth: 1,
        borderRadius: 4,
      },
      {
        label: "GoldenReel Studios",
        data: [50, 25, 37.5, 12.5, 25],
        backgroundColor: ["#E74C3C"],
        borderColor: ["#E74C3C"],
        borderWidth: 1,
        borderRadius: 4,
      },
      {
        label: "AceEdge Gaming",
        data: [50, 25, 37.5, 12.5, 25],
        backgroundColor: ["#1ABC9C"],
        borderColor: ["#1ABC9C"],
        borderWidth: 1,
        borderRadius: 4,
      },
      {
        label: "HighRoller Interactive",
        data: [50, 25, 37.5, 12.5, 25],
        backgroundColor: ["#28388A"],
        borderColor: ["#28388A"],
        borderWidth: 1,
        borderRadius: 4,
      },
      {
        label: "NextSpin Entrertainment",
        data: [100, 50, 75, 25, 50],
        backgroundColor: ["#3498DB"],
        borderColor: ["#3498DB"],
        borderWidth: 1,
        borderRadius: 4,
      },
      {
        label: "Fortuna Playmakers",
        data: [50, 25, 37.5, 12.5, 25],
        backgroundColor: ["#F39C12"],
        borderColor: ["#F39C12"],
        borderWidth: 1,
        borderRadius: 4,
      },

      {
        label: "HighRoller Interactive",
        data: [50, 25, 37.5, 12.5, 25],
        backgroundColor: ["#28388A"],
        borderColor: ["#28388A"],
        borderWidth: 1,
        borderRadius: 4,
      },
      {
        label: "NextSpin Entrertainment",
        data: [100, 50, 75, 25, 50],
        backgroundColor: ["#3498DB"],
        borderColor: ["#3498DB"],
        borderWidth: 1,
        borderRadius: 4,
      },
      {
        label: "Fortuna Playmakers",
        data: [50, 25, 37.5, 12.5, 25],
        backgroundColor: ["#F39C12"],
        borderColor: ["#F39C12"],
        borderWidth: 1,
        borderRadius: 4,
      },

      {
        label: "HighRoller Interactive",
        data: [50, 25, 37.5, 12.5, 25],
        backgroundColor: ["#28388A"],
        borderColor: ["#28388A"],
        borderWidth: 1,
        borderRadius: 4,
      },
      {
        label: "NextSpin Entrertainment",
        data: [100, 50, 75, 25, 50],
        backgroundColor: ["#3498DB"],
        borderColor: ["#3498DB"],
        borderWidth: 1,
        borderRadius: 4,
      },
      {
        label: "Fortuna Playmakers",
        data: [50, 25, 37.5, 12.5, 25],
        backgroundColor: ["#F39C12"],
        borderColor: ["#F39C12"],
        borderWidth: 1,
        borderRadius: 4,
      },
    ],
  };

  const customOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
        anchor: "end",
        align: "start",
        formatter: (value) => value.toLocaleString(),
        color: "black",
        font: {
          family: "Poppins-regular",
          weight: "bold",
        },
      },
      tooltip: {
        enabled: true,
        mode: "nearest",
        intersect: false,
        backgroundColor: "#252729",
        titleFont: {
          family: "Poppins-regular",
          size: 16,
          weight: "bold",
        },
        bodyFont: {
          family: "Poppins-regular",
          size: 14,
        },
        padding: 15,
        displayColors: true,
      },
    },
    scales: {
      // Aqui que deve estar `stacked`
      x: {
        stacked: true,
        barThickness: 5,
        ticks: {
          color: "#92929E",
          callback: function (value, index, ticks) {
            if (ticks.length > 10) {
              return index % 3 === 0 ? this.getLabelForValue(value) : "";
            }
            return this.getLabelForValue(value);
          },
        },
      },
      y: {
        beginAtZero: true,
        stacked: true, // `stacked` estava dentro de `plugins`, movi para `scales`
        ticks: {
          callback: function (value) {
            return value / 1000 + "k";
          },
        },
      },
    },
    interaction: {
      mode: "index",
      intersect: false,
    },
  };

  return (
    <div className="provider-distribution-container">
      {isApiRunning ? (
        <RebetLoader height={"150px"} width={"150px"} />
      ) : (
        <>
          <div className="provider-distribution-chart">
            <DashboardBarChart
              data={keyFeatures}
              title="Provider Distribution by Bets"
              display={true}
              customOptions={customOptions}
              isApiRunning={isApiRunning}
            />
          </div>
          <div className="providers">
            {keyFeatures.datasets.map((provider, index) => (
              <div key={index} className="provider">
                <div
                  className="provider-color"
                  style={{ backgroundColor: provider.backgroundColor[0] }}
                ></div>
                <div className="provider-name">{provider.label}</div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default ProviderDistribution;
